import { RegisterProps } from '@msc-b2c/interfaces/types';
import { Register } from './Register';

export function RegisterWrapper(registerProps: Readonly<RegisterProps>) {
  return <Register {...registerProps} />;
}

RegisterWrapper.aemResourceType = 'b2c-website-foundation/components/mymsc/form/register';

export default RegisterWrapper;
